import ErrorsManager, { ErrorModel } from './ErrorsManager';

// --- Constants ---

export const API_ERROR = 'API ERROR';
export const ADAPTOR_ERROR = 'ADAPTOR ERROR';
export const BUSINESS_ERROR = 'BUSINESS ERROR';
export const COMPONENT_ERROR = 'COMPONENT ERROR';
export const UNRECOGNIZED_ERROR = 'UNRECOGNIZED ERROR';

// --- Types ---

// Define a Union Type of all valid error strings
export type ErrorType =
    | typeof API_ERROR
    | typeof ADAPTOR_ERROR
    | typeof BUSINESS_ERROR
    | typeof COMPONENT_ERROR
    | typeof UNRECOGNIZED_ERROR;

const possibleTypes: string[] = [
    API_ERROR,
    ADAPTOR_ERROR,
    BUSINESS_ERROR,
    COMPONENT_ERROR,
];

interface ErrorWithTypeParams {
    type: string;
    error: any;
}

// --- Class ---

class ErrorWithType extends Error {
    constructor({ type, error }: ErrorWithTypeParams) {
        // Initialize base Error
        super(error instanceof Error ? error.message : String(error));

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorWithType);
        }

        // Determine if the provided type is one of our known constants
        const errorType: ErrorType = possibleTypes.includes(type)
            ? (type as ErrorType)
            : UNRECOGNIZED_ERROR;

        /**
         * The original JS logic returns the result of ErrorsManager.createError.
         * We cast to 'any' or 'ErrorModel' because constructors technically
         * return 'this' by default in TS.
         */
        return ErrorsManager.createError({
            type: errorType,
            error,
        }) as any;
    }
}

export { ErrorWithType };
